export default function (value) {
  if (typeof value !== 'number') {
    return value
  }
  const roundedPercent = Math.round(value * 10000) / 100
  return roundedPercent + ((roundedPercent % 1 !== 0 && roundedPercent * 10 % 1 === 0) ? '0' : (roundedPercent % 1 !== 0 ? '' : '.00')) + ' %'
}
